import "./AttorneyFeeHearings.module.css";
import Mainheader from "./sections/Mainheader";
import AttorneySFeeHearingsHero from "./sections/AttorneySFeeHearingsHero";
import Footer from "@/reusable_sections/Footer";
import HowTheFirmAssists from "./sections/HowTheFirmAssists";
import AttorneyFeeFactors from "./sections/AttorneyFeeFactors";
import Inquiry from "./sections/Inquiry";
export default function AttorneyFeeHearingsPage() {
  return <div>
      <Mainheader />
      <AttorneySFeeHearingsHero />
      <HowTheFirmAssists />
      <AttorneyFeeFactors />
      <Inquiry />
      <Footer />
    </div>;
}